import { render, staticRenderFns } from "./PoliciesDetails.vue?vue&type=template&id=1a3de32c&scoped=true&"
import script from "./PoliciesDetails.vue?vue&type=script&lang=js&"
export * from "./PoliciesDetails.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesDetails.vue?vue&type=style&index=0&id=1a3de32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3de32c",
  null
  
)

export default component.exports